import { LabelTranslation } from "~/types";

export enum FilterType {
    DISCLOSURE = "disclosure",
    COMPANY = "company",
    YEAR = "year",
    INDUSTRY = "industry"
}

export interface FilterOption {
    id: number;
    type: FilterType;
    label: LabelTranslation | string;
}

/**
 *  API Response Data for filters
 */
export interface ResFilters {
    Year: string[];
    IndustryID: string[];
    CompanyID: string[];
}

export interface ResAllIndustries {
    data: ResIndustryData[];
}

export interface ResIndustryData {
    IndustryID: number;
    Name: string;
    FrName: string;
}

export interface ResAllCompanies {
    companies: ResCompanyData[];
}

export interface ResCompanyData {
    CompanyId: number;
    Name: string;
    Rank: string;
    IndustryID?: number;
}
